<mat-toolbar class="toolbar-example">
    <span>Add Panel Members</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<div class="search-div">
    <mat-form-field class="search-form-field">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" [(ngModel)]="filterName" name="filterName">
        <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)= "onClear()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>
<div class="panelMember-table">
    <table mat-table [dataSource]="listData" class="mat-elevation-z8" mat-sort>

    
        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> Sl No. </th>
            <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </td>
        </ng-container>

        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.panelMemberName}} -
        </ng-container>

        
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef> Contact No. </th>
            <td mat-cell *matCellDef="let element"> {{element.contactNo}} </td>
        </ng-container>
        
        

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
            class="example-element-row"></tr>
    </table>
        <input matInput [(ngModel)]="element" [hidden]="true">
</div>
<div class="button-row action-btn">
    <button mat-raised-button class="btn-color-example" [mat-dialog-close]="element" (click)='panelMemberChanged()'>Apply</button>
    <button mat-raised-button class="btn-cancel" [mat-dialog-close]>Close</button>
</div>




<!-- <div class="search-div">
    <mat-form-field class="search-form-field">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" [(ngModel)]="filterName" name="filterName">
        <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)= "onClear()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>
<div class="panelMember-table">
    <table mat-table [dataSource]="listData" class="mat-elevation-z8">

       ------- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -------------

        --------- Position Column ------------
        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> Sl No. </th>
            <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </td>
        </ng-container>

        <-------- Selection Column -----------
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        -------- Name Column ---------
        <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef> Candidate Name </th>
            <td mat-cell *matCellDef="let element"> {{element.panelMemberName}} -
        </ng-container>

        ---------- Assigned/Not Assigned status Column -------------
        ---------- <ng-container matColumnDef="assignStatus">
            <th mat-header-cell *matHeaderCellDef>Assigning Status </th>
            <td mat-cell *matCellDef="let element">
                {{element.panelPanelMembers?.length == 0 ? 'Not-Assgnied' : 'Assigned'}}</td>
        </ng-container> -------

        -------- Email-Id Column -------
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        -------- Contact No. Column -------
        <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef> Contact No. </th>
            <td mat-cell *matCellDef="let element"> {{element.contactNo}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
            class="example-element-row"></tr>
    </table>
    -------- <mat-form-field [hidden]="true"> ----------
        <input matInput [(ngModel)]="element" [hidden]="true">
    ----------- </mat-form-field> --------------
</div>
<div class="button-row">
    <button mat-raised-button color="primary" [mat-dialog-close]="element" (click)='panelMemberChanged()'>Apply</button>
    <button mat-raised-button color="warn" [mat-dialog-close]>Close</button>
</div> -->